import React from 'react';
import HomeContainer from '../HomeContainer';

const CoursePlan3 = () => {
  return (
    <HomeContainer>
    <div>
      <h5>Advanced Generative Ai</h5>
      <p>
        Coming soon...
        <ul>
        <li>1...</li>
        <li>2...</li>
        </ul>
      </p>
    </div>
    </HomeContainer>
  );
};

export default CoursePlan3;
